<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        parallelAxis: [
          { dim: 0, name: "Price" },
          { dim: 1, name: "Mass" },
          { dim: 2, name: "Amount" }
        ],
        series: [
          {
            type: "parallel",
            data: [
              [12.99, 23, 93],
              [9.99, 15, 85],
              [29.99, 34, 112]
            ]
          }
        ]
      }
    };
  }
};
</script>
